import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import ProductBasicInformation from './NewCompanyForms/CompanyBasicInformation';
import CompanyAddress from './NewCompanyForms/CompanyAddress';
import ProductHeader from './NewCompanyForms/CompanyHeader';
import ProductUpload from './NewCompanyForms/CompanyUpload';
// import ProductDetails from './NewCompanyForms/CompanyDetails';
import ProductType from './NewCompanyForms/CompanyType';
import ProductTags from './NewCompanyForms/CompanyTags';
import CompanyPeriod from './NewCompanyForms/CompanyPeriod';
import { useMutation } from '@apollo/client';
import { COMPANY_CREATE } from '../../../lib/mutations';
import axios from 'axios';
import Resizer from 'react-image-file-resizer';

const schema = yup
  .object({
    name: yup.string().required('Энэ талбарыг оруулна уу!'),
    phone: yup.string().required('Энэ талбарыг оруулна уу!'),
    email: yup.string().required('Энэ талбарыг оруулна уу!'),
    registerNumber: yup.string().required('Энэ талбарыг оруулна уу!'),
    companyRegister: yup.string().required('Энэ талбарыг оруулна уу!'),
    city: yup.string().required('Энэ талбарыг оруулна уу!'),
    country: yup.string().required('Энэ талбарыг оруулна уу!'),
    address: yup.string().required('Энэ талбарыг оруулна уу!'),
    address1: yup.string().required('Энэ талбарыг оруулна уу!'),
    companyType: yup.string().required('Энэ талбарыг оруулна уу!'),
    payment: yup.string().required('Энэ талбарыг оруулна уу!'),
    conditionPeriod: yup.string().required('Энэ талбарыг оруулна уу!')
  })
  .required();

const CompanyAdd = () => {
  const navigage = useNavigate();
  const [postCompanyData, { data }] = useMutation(COMPANY_CREATE);
  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const [loading, setLoading] = useState(false);
  const { handleSubmit, reset } = methods;
  const [files, setFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);

  const imageUploader = image => {
    setLoading(true);
    Resizer.imageFileResizer(
      image,
      800,
      600,
      'WEBP',
      100,
      0,
      uri => {
        axios
          .post(`${process.env.REACT_APP_FILE_URL}/uploadimage`, {
            image: uri
          })
          .then(response => {
            if (response.data?.url && response.data?.public_id) {
              const newImageUrl = {
                url: String(response?.data?.url),
                public_id: String(response?.data?.public_id),
                bucketname: image.name
              };

              setImageUrls(prevUrls => [...prevUrls, newImageUrl]);
              setLoading(false);
            }
          })
          .catch(error => {
            console.log('CLOUDINARY UPLOAD FAILED', error);
          });
      },
      'base64',
      400,
      300
    );
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      postCompanyData({
        variables: {
          input: {
            companyType: data.companyType,
            name: data.name,
            phone: data.phone,
            email: data.email,
            companyRegister: data.companyRegister,
            registerNumber: data.registerNumber,
            logo: imageUrls[0],
            tags:
              data.tags && Array.isArray(data.tags) && data.tags.length > 0
                ? [...data.tags.map(item => item.value)]
                : [],
            address: {
              country: data.country,
              city: data.city,
              address: data.address,
              address1: data.address1
            },
            payment: {
              payment: parseFloat(data.payment),
              conditionPeriod: parseFloat(data.conditionPeriod),
              status: false
            }
          }
        }
      });
      const keys = Object.keys(data);
      for (const key of keys) {
        submittedValues[key] = '';
      }
      reset({ ...submittedValues });
    }
  };

  useEffect(() => {
    if (data) {
      if (data?.companyCreate?.status?.code === 200) {
        toast.success(`Амжиллтай илгээлээ`, {
          theme: 'colored'
        });
        navigage(`/company/company-update/${data?.companyCreate?.data?._id}`);
      } else {
        toast.warning(`${data?.companyCreate?.status?.moreInfo}`, {
          theme: 'colored'
        });
      }
    }
  }, [data]);

  const handleRemove = path => {
    let removeItem = '';
    imageUrls.forEach(item => {
      if (item.bucketname === path) {
        removeItem = item.public_id;
      }
    });
    setFiles(files.filter(file => file.path !== path));
    const updatedImageUrls = imageUrls.filter(
      image => image.bucketname !== path
    );
    setImageUrls(updatedImageUrls);
    if (removeItem) {
      axios
        .post(`${process.env.REACT_APP_FILE_URL}/removeimage`, {
          public_id: removeItem
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={12}>
            <ProductHeader />
          </Col>
          <Col lg={8}>
            <ProductBasicInformation />
            <ProductUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
            <CompanyAddress />
          </Col>
          <Col lg={4}>
            <div className="sticky-sidebar">
              <ProductType />
              <ProductTags />
              <CompanyPeriod />
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default CompanyAdd;
